export default {"src":"/_next/static/media/placeholder.ba7a6adf.svg","height":72,"width":72};